import {debugLog} from "../../lib.js"

/**
 * Author: Stefan Haack (https://shaack.com)
 */
export const gameEventAction = {
  NEW_MOVE: "NEW_MOVE",
  OFFER_DRAW: "OFFER_DRAW",
  RESIGN: "RESIGN",
  LEFT_APP: "LEFT_APP",
  PREGAME_ABORT: "PREGAME_ABORT",
  DRAW_OFFER_DECLINE: "DRAW_OFFER_DECLINE",
  QUIT: "QUIT",
  SKIP: "SKIP",
  REQUEST_REMATCH: "REQUEST_REMATCH",
  ACCEPT_REMATCH: "ACCEPT_REMATCH",
};

export class GambitWebSocketConnection {
  constructor(props) {
    this.props = {
      endpoint: props.endpoint,
      onopen: undefined,
      onclose: undefined,
      onInitGame: undefined,
      onGameState: undefined,
      debug: false,
    };
    Object.assign(this.props, props);
    this.state = {
      websocket: undefined,
    };
  }

  open() {
    this.autoReconnect = true;
    this.state.webSocket = new WebSocket(this.props.endpoint);
    this.state.webSocket.addEventListener("open", (event) => {
      debugLog(this.props.debug, "WebSocketConnection.onopen", event);
      if (this.props.onopen) {
        this.props.onopen(event);
      }
    });
    this.state.webSocket.addEventListener("close", (event) => {
      debugLog(this.props.debug, "WebSocketConnection.onclose", event);
      if (this.props.onclose) {
        this.props.onclose(event);
      }
      if (this.autoReconnect) {
        this.open();
      }
    });
    this.state.webSocket.addEventListener("message", (event) => {
      this.onmessage(event);
    });
  }

  close() {
    this.autoReconnect = false;
    this.state.webSocket.close();
  }

  send(message) {
    debugLog(this.props.debug, "WebSocketConnection send", message);
    this.state.webSocket.send(JSON.stringify(message));
  }

  onmessage(event) {
    const data = JSON.parse(event.data);
    debugLog(this.props.debug, "WebSocketConnection.onmessage", data);
    if (data["blackUID"] && data["whiteUID"]) {
      if (this.props.onInitGame) {
        debugLog(this.props.debug, "=> onInitGame");
        this.props.onInitGame(data);
      }
    } else {
      // is GameState message
      if (this.props.onGameState) {
        debugLog(this.props.debug, "=> onGameState");
        this.props.onGameState(data);
      }
    }
  }

  sendLobbyGame(accessToken, timeControl, stake, debugFen = undefined, inc) {
    const data = {
      _increment: inc,
      _logauid: "", // todo try to remove this
      _time_control: timeControl,
      _token: accessToken,
      _gstake: stake,
    };
    this.send(data);
  }

  sendGameEvent(token, action, payload = "") {
    const data = {
      action: action,
      _getoken: token, // "Game Event"-token, standard Firebase Auth token.
      _payload: payload,
      // Payload. In the case of NEW_MOVE action, UCI-notation for move. Contents will be
      // ignored for action where the only relevant field is the sender (OFFER_DRAW
      // for instance).
    };
    this.send(data);
  }

  sendMove(token, notation) {
    this.sendGameEvent(token, gameEventAction.NEW_MOVE, notation);
  }

  sendReconnect(token) {
    const data = {
      _recontoken: token,
    };
    this.send(data);
  }
}
